/**
 * @generated SignedSource<<d28b4753f797d24086040f5161e68c9e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type useEditorAddCommentPermissionFragment_content$data = Result<{
  readonly id: string | null;
  readonly operations: ReadonlyArray<{
    readonly operation: string | null;
    readonly targetType: string | null;
  } | null> | null;
  readonly type: string | null;
  readonly " $fragmentType": "useEditorAddCommentPermissionFragment_content";
}, unknown>;
export type useEditorAddCommentPermissionFragment_content$key = {
  readonly " $data"?: useEditorAddCommentPermissionFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEditorAddCommentPermissionFragment_content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useEditorAddCommentPermissionFragment_content",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "concreteType": "OperationCheckResult",
      "kind": "LinkedField",
      "name": "operations",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "operation"
        },
        {
          "kind": "ScalarField",
          "name": "targetType"
        }
      ]
    }
  ],
  "type": "Content"
};

(node as any).hash = "def264edeeb69944e6aa6490f6201cca";

export default node;
